import { Card, CardContent } from "@/components/ui/card";
import { Calculator } from "lucide-react";
import { useCurrency } from "@/hooks/useUserCurrency";

interface InterestCalculatorProps {
  amount: string;
  interestRate: string;
}

export function InterestCalculator({ amount, interestRate }: InterestCalculatorProps) {
  const principal = parseFloat(amount) || 0;
  const rate = parseFloat(interestRate) || 0;
  const { format } = useCurrency();
  
  const monthlyInterest = (principal * rate) / 100;
  const totalWithInterest = principal + monthlyInterest;

  if (!principal || !rate) {
    return null;
  }

  return (
    <Card className="border-primary/20 bg-primary/5">
      <CardContent className="p-4">
        <div className="flex items-center gap-2 mb-3">
          <Calculator className="h-4 w-4 text-primary" />
          <h3 className="font-semibold text-sm">Cálculo Automático</h3>
        </div>
        <div className="space-y-2 text-sm">
          <div className="flex justify-between">
            <span className="text-muted-foreground">Valor emprestado:</span>
            <span className="font-medium">{format(principal)}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-muted-foreground">Juros mensal ({rate}%):</span>
            <span className="font-medium text-warning">{format(monthlyInterest)}</span>
          </div>
          <div className="flex justify-between pt-2 border-t">
            <span className="font-semibold">Total a receber:</span>
            <span className="font-bold text-success">{format(totalWithInterest)}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
